import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=4a1d80c8&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivacy.vue?vue&type=style&index=0&id=4a1d80c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1d80c8",
  null
  
)

export default component.exports